import { Component, OnInit, Input, EventEmitter, Output } from "@angular/core";

import * as dto from "../models/dashboard.dto";

import { SidePanelBase } from '../../common/components/side-panel-base.class';
import { SidePanelService } from '../../common/services/side-panel.service';

@Component ({
    selector: "add-new-widget",
    templateUrl: "./add-new-widget.component.html",
    styleUrls: ["./add-new-widget.component.scss"],
    standalone: false
})

export class AddNewWidgetComponent extends SidePanelBase {
    static componentName = 'addnewwidgetcomponent';
    isOpen: boolean = false;
    availableWidgetTypes: dto.WidgetKind[] = [];

    constructor(public sidePanelService: SidePanelService) {
        super();

        this.sidePanelService.update().subscribe((result) => {
            let currentWidgets: dto.Widget[] = result.data.sections.find(x => x.componentName === 'addnewwidget').data;
            this.availableWidgetTypes = [];

            let keys = Object.keys(dto.WidgetKind);
            for (let widget of keys) {
                if (currentWidgets.findIndex(x => x.component === widget) === -1)
                    this.availableWidgetTypes.push(dto.WidgetKind[widget]);
            }
        });
    }

    add(w: dto.Widget): void {
        this.saveMethod.emit(w);
    }
}
